import { render, staticRenderFns } from "./publishCourseUsage.vue?vue&type=template&id=0b031b31"
import script from "./publishCourseUsage.vue?vue&type=script&lang=js"
export * from "./publishCourseUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports